<nav class="navbar navbar-expand-lg" style="background-color: #00bab5">
    <img src="../../assets/img/logo.png" style="height: 50px;">
  </nav>